const lightTheme = {
  background: '#F4F7F6',
  backgroundElement: '#F8FBFA',
  backgroundSelected: '#DDF8F4',
  surface: '#FFFFFF',
  surfaceElevated: '#FFFFFF',
  surfaceMuted: '#F0F8F6',
  surfaceStrong: '#E3F2F0',
  border: '#CDE2DF',
  borderStrong: '#A8CCC7',
  text: '#0C4E49',
  textSecondary: '#3D625E',
  textTertiary: '#68847F',
  institutional: '#0C4E49',
  brand: '#0C4E49',
  brandPressed: '#083D39',
  brandSubtle: '#DDF8F4',
  action: '#32C9C1',
  actionPressed: '#27B7B0',
  actionSubtle: '#D9F7F4',
  onAction: '#0C4E49',
  highlight: '#6ADBCB',
  highlightSubtle: '#E5FAF7',
  success: '#168978',
  successSubtle: '#DDF5EF',
  warning: '#A96D16',
  warningSubtle: '#FFF3D8',
  error: '#B94B5A',
  errorSubtle: '#FBE9EC',
  income: '#168978',
  incomeSubtle: '#DDF5EF',
  expense: '#B94B5A',
  expenseSubtle: '#FBE9EC',
  pending: '#A96D16',
  pendingSubtle: '#FFF3D8',
  scrim: 'rgba(5, 35, 32, 0.54)',

  featuredSurface: '#F8FCFB',
  featuredBorder: '#BBDDD8',
  featuredTextSecondary: '#416A65',
  featuredIconSurface: '#E0F3FF',
  featuredIcon: '#3D84F6',
  onBrand: '#FFFFFF',
  onInstitutional: '#FFFFFF',
  onInstitutionalMuted: 'rgba(255, 255, 255, 0.72)',
  onInstitutionalSubtle: 'rgba(255, 255, 255, 0.64)',
  institutionalDivider: 'rgba(255, 255, 255, 0.16)',
  institutionalPressed: 'rgba(255, 255, 255, 0.10)',
  heroGlow: 'rgba(55, 176, 240, 0.22)',
  heroGradientStart: '#0C4E49',
  heroGradientMiddle: '#096B65',
  heroGradientEnd: '#07545A',
  fabShadow: '#0C4E49',
  toastShadow: '#0C4E49',
  neutral: '#CDE2DF',
  navy: '#0C4E49',

  // Aliases temporários: não constituem uma segunda paleta.
  white100: '#FFFFFF',
  gray100: '#F4F7F6',
  gray200: '#CDE2DF',
  gray300: '#A8CCC7',
  gray400: '#68847F',
  gray500: '#3D625E',
  typography100: '#0C4E49',
  typography200: '#3D625E',
  typography300: '#A8CCC7',
  typography400: '#68847F',
  typography500: '#3D625E',
  primaryColor: '#32C9C1',
  secondaryColor: '#68847F',
  successColor: '#168978',
  dangerColor: '#B94B5A',
  infoColor: '#37B0F0',
  warningColor: '#A96D16',
  backgroundColor: '#F4F7F6',
  lightColor: '#E3F2F0',
  textColor: '#0C4E49',
  cardBackground: '#FFFFFF',
  listBackground: '#F0F8F6',
  modalBackground: '#FFFFFF',
  inputBackground: '#F0F8F6',
  inputBorder: '#CDE2DF',
  inputFocusBorder: '#32C9C1',
  inputFocusShadow: 'rgba(50, 201, 193, 0.25)',
  navBackground: 'rgba(244, 247, 246, 0.92)',
};

export default lightTheme;
